import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {SubCategoryService} from '../../../shared/services/sub-category.service';

@Component({
    selector: 'app-add-sub-category',
    templateUrl: './add-sub-category.component.html',
    styleUrls: ['./add-sub-category.component.scss']
})
export class AddSubCategoryComponent implements OnChanges {
    addSubCategoryForm: FormGroup;
    submitted: any = false;
    submitting: any = false;
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                private subCategoryService: SubCategoryService) {
    }

    ngOnChanges(): void {
        this.refresh();
    }

    refresh() {
        this.addSubCategoryForm = this.fb.group({
            'name': ['', Validators.required],
        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addSubCategoryForm.patchValue({
            'name': (this.data && this.data['name']) ? this.data['name'] : '',
        });
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-category').toggleOpen();
    }

    submit() {
        this.submitted = true;
        if (!this.addSubCategoryForm.valid) {
            return;
        }

        if (this.submitted) {
            const params = {
                'name': (this.addSubCategoryForm.value && this.addSubCategoryForm.value.name) ? this.addSubCategoryForm.value.name : '',
            };
            this.submitting = true;
            this.subCategoryService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addSubCategoryForm.reset();
                    this.addSubCategoryForm.patchValue({
                        'name': '',
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addSubCategoryForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addSubCategoryForm.value && this.addSubCategoryForm.value.name) ? this.addSubCategoryForm.value.name : ''
            };
            this.submitting = true;
            this.subCategoryService.update(this.data['id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                }
            });
        }
    }
}
